import "core-js/modules/es.object.to-string.js";
/*
 *  Geo Tools
 *    Provides common tools and funcitons for geo related items, including
 *    callbacks etc.
 *
 *  Dependencies:
 *    js-cookie - Cookies is used to cache data.
 *
 *  Version:
 *    1.0.0 - 2018/09/20
 */

import Cookies from 'js-cookie';
var CACHE_GEO_DATA;
var IS_FETCHING = false;
export var COOKIE_GEO_CACHE = 'GeoDataCache';
export var GEO_LISTENERS = [];
export var fetchGeo = function fetchGeo(callback) {
  //Have we already fetched?
  if (CACHE_GEO_DATA) return callback(CACHE_GEO_DATA);
  GEO_LISTENERS.push(callback);

  //Are we already fetching?
  if (IS_FETCHING) return;

  //Check cookies
  try {
    CACHE_GEO_DATA = Cookies.get(COOKIE_GEO_CACHE);
    if (typeof CACHE_GEO_DATA === "string") CACHE_GEO_DATA = JSON.parse(CACHE_GEO_DATA);
  } catch (e) {
    console.error('Failed to parse GeoData, not a huge issue', e);
    CACHE_GEO_DATA = null;
  }
  if (CACHE_GEO_DATA) return callback(CACHE_GEO_DATA);

  //Fetch from Third Party
  IS_FETCHING = true;
  $.ajax({
    url: '//api.ipstack.com/check',
    data: {
      access_key: '139844185cefca4a1907ae7a27245eb7'
    },
    method: "GET",
    dataType: 'jsonp',
    success: function success(data) {
      //Trigger our listeners and cache
      CACHE_GEO_DATA = data;
      IS_FETCHING = false;
      try {
        Cookies.set(COOKIE_GEO_CACHE, JSON.stringify(data), {
          expires: 1
        });
      } catch (e) {
        console.error('Failed to cache geo data, not a major issue', e);
      }
      GEO_LISTENERS.forEach(function (gl) {
        return gl(data);
      });
      $(document).trigger('onGeo', data);
    },
    error: function error() {
      var _console;
      //Err.
      console.error("Failed to fetch geo data");
      (_console = console).error.apply(_console, arguments);
    }
  });
};